<template>
  <div>
    <v-hover
      v-slot="{ hover }"
      v-if="period_teacher_govem_manpower_report.period_college_enable === '1' || period_teacher_govem_manpower_report.period_college_enable === 1"
    >
      <v-card
        :elevation="hover ? 16 : 6"
        class="alert-card mb-4"
        rounded="lg"
        :class="{ 'on-hover': hover }"
        :style="{ borderLeft: '6px solid #FF9800' }"
      >
        <v-card-text class="pa-5">
          <v-row align="center">
            <v-col cols="12" md="8">
              <div class="d-flex align-start mb-2">
                <v-icon size="32" color="orange darken-1" class="mr-3"
                  >mdi-briefcase</v-icon
                >
                <div>
                  <h2 class="text-subtitle-1 font-weight-bold">
                    พนักงานราชการ - สถานศึกษารายงานการการบริหารอัตรากำลัง และการเบิกจ่ายค่าตอบแทน
                  </h2>
                  <p class="text-caption grey--text mb-0">
                    ให้วิทยาลัยดำเนินการรายงานก่อนระบบปิด
                  </p>
                </div>
              </div>
              <div class="d-flex align-center ml-2">
                <v-icon color="error" small class="mr-2"
                  >mdi-calendar-clock</v-icon
                >
                <span class="deadline-text text-body-2 font-weight-medium">
                  ปิดระบบ:
                  {{
                    formatDeadline(
                      period_teacher_govem_manpower_report.period_college_stop
                    )
                  }}
                </span>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div
                class="alert-actions d-flex flex-column align-md-end align-center"
              >
                <flip-countdown
                  :deadline="
                    period_teacher_govem_manpower_report.period_college_stop +
                      ' 16:30:00'
                  "
                  :labels="labels"
                  class="countdown-timer mb-3"
                ></flip-countdown>
                <v-btn
                  color="warning"
                  large
                  to="/iven/gov_em/government_employee"
                  class="action-btn"
                  elevation="4"
                  rounded
                >
                  <v-icon left>mdi-arrow-right-circle</v-icon>
                  ดำเนินการ
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-hover>
  </div>
</template>
<script>
export default {
  data() {
    return {
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      },
      period_teacher_govem_manpower_report: {},
      ApiKey: "HRvec2021"
    };
  },
  mounted() {
    this.fetchPeriodTeacherGovemManpowerReport();
  },
  methods: {
    async fetchPeriodTeacherGovemManpowerReport() {
      try {
        let result_period_college = await this.$http.post(
          "period_college.php",
          {
            ApiKey: this.ApiKey,
            period_college_enable: "1",
            period_college_id: "80104"
          }
        );
        this.period_teacher_govem_manpower_report =
          result_period_college.data || {};
      } catch (error) {
        console.error("Error fetching government employee period:", error);
        this.period_teacher_govem_manpower_report = {};
      }
    },
    formatDeadline(deadline) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(deadline).toLocaleDateString("th-TH", options);
    }
  }
};
</script>
